__turbopack_context__.v({
  "embed": "Video-module-scss-module__5L4yMq__embed",
  "videoSection": "Video-module-scss-module__5L4yMq__videoSection",
});
